var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "一卡通信息",
        visible: _vm.visible,
        width: "1000px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.reset,
      },
    },
    [
      _c("div", { staticClass: "card-product-name" }, [
        _vm._v("商品名称：" + _vm._s(_vm.productName || "-")),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            data: _vm.cards,
            "row-key": "id",
            size: "small",
            border: "",
            "max-height": "480",
            "empty-text": "暂无已发放的一卡通信息",
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "cardNo", label: "卡号", "min-width": "180" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cardTypeDesc",
              label: "卡密类型",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cardStatusDesc",
              label: "卡状态",
              "min-width": "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "validityDesc",
              label: "有效期",
              "min-width": "260",
            },
          }),
          _vm._v(" "),
          _vm.hasSelfCard
            ? _c("el-table-column", {
                attrs: { label: "手机号", "min-width": "130" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                Number(scope.row.cardType) === 0
                                  ? scope.row.phone || "-"
                                  : "-"
                              ) +
                              "\n      "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3901813734
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasSelfCard
            ? _c("el-table-column", {
                attrs: { label: "卡使用状态", "min-width": "110" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                Number(scope.row.cardType) === 0
                                  ? scope.row.cardUseStatusDesc || "-"
                                  : "-"
                              ) +
                              "\n      "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2121023176
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.close } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }